import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Href } from "../../../constants";
import { MenuItem } from "../../../data/layout/Header";
import { useAppDispatch, useAppSelector } from "../../../reduxToolkit/hooks";
import { setSidebarOpen } from "../../../reduxToolkit/reducers/layoutSlice";
import SubMenu from "./SubMenu";
import UseOutsideDropdown from "../../../utils/UseOutsideDropdown";
import MainMenu from "./MainMenu";
import MenuImageList from "./MenuImageList";

const Navigation = () => {
  const [openSections, setOpenSections] = useState<{ [key: string]: boolean }>({});
  const { sidebarOpen } = useAppSelector((state) => state.layout);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { ref, isComponentVisible, setIsComponentVisible } = UseOutsideDropdown(sidebarOpen);

  const toggleSection = (title: string) => setOpenSections((prevState) => ({ [title]: !prevState[title] }));

  const toggleMenu = () => {
    setIsComponentVisible(!sidebarOpen);
    dispatch(setSidebarOpen(!isComponentVisible));
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  useEffect(() => {
    dispatch(setSidebarOpen(isComponentVisible));
  }, [dispatch, isComponentVisible]);

  useEffect(() => setIsComponentVisible(sidebarOpen), [setIsComponentVisible, sidebarOpen]);
  return (
    <nav ref={ref} className={`sidebar-nav ${isComponentVisible ? "open" : ""}`}>
      <div className="menu-header">
        <h5 className="menu-title">Menu</h5>
        <a href={Href} className="close-btn" onClick={toggleMenu}>
          <i className="ri-close-line" />
        </a>
      </div>
      <ul className="menu-items">
        {MenuItem &&
          MenuItem.map((mainMenu, index) => (
            <li className={`${mainMenu.children && 'expand-btn'} ${!mainMenu.megaMenuImage && !mainMenu.megaMenu ? "dropdown-menus" : ""}`} key={index}>
              <Link to={mainMenu.path || Href} className={`menu-item ${openSections[mainMenu.title || ''] ? "open" : ""}`} onClick={() => { toggleSection(mainMenu.title || ''); if (!mainMenu.children) toggleMenu(); }}>
                {t(mainMenu.title || '')}
              </Link>
              {mainMenu.megaMenuImage && <MenuImageList mainMenu={mainMenu.children || []} toggleMenu={toggleMenu} />}
              {!mainMenu.megaMenuImage && !mainMenu.megaMenu && mainMenu.children && (
                <ul className="dropdown-megamenu sample link-list">
                  <SubMenu menu={mainMenu.children} level={0} toggleMenu={toggleMenu} />
                </ul>
              )}
              {mainMenu.megaMenu && <MainMenu mainMenu={mainMenu.children || []} toggleMenu={toggleMenu} />}
            </li>
          ))}
      </ul>
    </nav>
  );
};

export default Navigation;
